module.exports = __webpack_public_path__ + "static/media/elavopathway_log.3da26587.png";